<script>
    import {
        DecimalInput,
        NotificationModal,
    } from "../../../../../Components/Common/index.svelte";

    import { isObjectEmpty } from "../../../../../Utils/utilFunctions.svelte";

    export let isModalOpen = false,
        itemObj = {},
        isConfirming = false,
        confirmAction = () => {},
        closeModal = () => {};

    $: isItemExistsInDB = itemObj && itemObj.id;
    $: isItemExistsInModal = itemObj && itemObj.tempId;
    $: isEditItem = isItemExistsInDB || isItemExistsInModal;

    $: if (isModalOpen && itemDescriptionInput) itemDescriptionInput.focus();

    $: isValidItemDescription = itemObj.encounterItemDescription
        ? itemObj.encounterItemDescription.length >= 3
        : true;

    $: isSaveBtnDisabled =
        isObjectEmpty(itemObj) ||
        !itemObj.encounterItemDescription ||
        !isValidItemDescription ||
        !itemObj.feeCharged;

    $: btnOptions = [
        {
            text: isConfirming ? "Saving" : "Save",
            isConfirming,
            loading: isConfirming || isSaveBtnDisabled,
            function: () => handleModifyFreeTextItem(),
        },
    ];

    let itemDescriptionInput;

    const handleKeyDown = (e) => {
        if (e.key == "Enter") !isSaveBtnDisabled && handleModifyFreeTextItem();
    };

    const handleModifyFreeTextItem = () => {
        const obj = { ...itemObj };
        confirmAction(obj);
    };
</script>

<NotificationModal
    title={isEditItem ? "Edit Item" : "Add Item"}
    {isModalOpen}
    {isConfirming}
    cancelText="Cancel"
    {closeModal}
    showConfirmBtn={false}
    {btnOptions}
    closeModalFunction={closeModal}
>
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div class="flex flex-col gap-y-4 p-4" on:keydown={handleKeyDown}>
        <div class="flex w-full flex-col gap-y-2">
            <p>Item Description</p> 
            <input
                type="text"
                class="input input-sm input-bordered {isValidItemDescription
                    ? ''
                    : 'input-error'}"
                bind:value={itemObj.encounterItemDescription}
                bind:this={itemDescriptionInput}
            />
            {#if !isValidItemDescription}
                <p class="text-sm text-error pt-1">Minimum 3 characters</p>
            {/if}
        </div>

        <div class="flex flex-col gap-y-2">
            <p>Fee</p>
            <DecimalInput bind:value={itemObj.feeCharged} />
        </div>
    </div>
</NotificationModal>
